module.exports = __webpack_public_path__ + "img/gourmet-babies.1cd62d91.jpg";